import { useAppSelector } from 'hooks';

import { AuthTags } from '~constants/authTags';
import { selectUserTags } from '~main/selectors/login';

// TAV-3101 gate: only users with `supportathome-claims:Admin` may reach the two irreversible claim
// actions, unfinalising a submitted claim and lodging the provider-wide claim to Services Australia.
// The API enforces the same tag on both routes; this hook only decides whether the controls are
// offered at all. Deliberately separate from `useCanManageInvoiceStatus`, which reads the same tag
// today but means something else (manual client-invoice status transitions) - keeping them apart
// means a future split of the two permissions does not have to untangle one shared hook.
export const useCanAdministerClaims = (): boolean => {
  const tags = useAppSelector(selectUserTags);
  return tags.includes(AuthTags.SUPPORTATHOME.CLAIMS.ADMIN);
};
